import { useState, useEffect, useRef } from "react";
import Common from "../../../helper/common";
import {
  ClubConfigLogTypeEnum,
  SearchTypeEnum,
} from "../../../constants/appConstant";
import { Button } from "../../../components/ui/button";
import * as yup from "yup";
import makeAnimated from "react-select/animated";
import AdvanceTable from "../../../components/advanceTable";
import { Formik } from "formik";
import {
  FormikInput,
  FormikMultiSelect,
  FormikSearchSelect,
  FormikSwitch,
} from "../../../components/formik-components";
import toast from "react-hot-toast";

const Logs = () => {
  const [data, setData] = useState({});
  const [sentAt, setSentAt] = useState(null);
  const [tillDate, setTillDate] = useState(null);
  const [search, setSearch] = useState(null);

  const [clubId, setClubId] = useState(null);
  // const [clubConfigLogType,setClubConfigLogType]=useState([]);
  const [accountList, setAccountList] = useState([]);
  const [servicePrice, setServicePrice] = useState(null);
  // const [grouped,setGrouped]=useState(false);

  const firstDayOfPrevMonth = Common.moment
    .utc()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const lastDayOfPrevMonth = Common.moment
    .utc()
    .subtract(1, "month")
    .endOf("month")
    .startOf("day")
    .format("YYYY-MM-DD");

  const formInitialValue = {
    sentAt: firstDayOfPrevMonth,
    tillDate: lastDayOfPrevMonth,
    search: null,
    clubId: [],
    clubConfigLogType: [],
    servicePrice: null,
    grouped: false,
  };

  const formValidations = yup.object({});
  const formikRef = useRef();
  const animatedComponents = makeAnimated();

  const onSubmitData = async (values, actions) => {
    await getData();
    actions.setSubmitting(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      getClubAccount();
    };
    fetchData();
  }, []);

  const resetFilters = () => {
    if (formikRef.current) {
      Object.keys(formInitialValue).forEach((key) => {
        formikRef.current.setFieldValue(key, formInitialValue[key] ?? "");
      });
      formikRef.current.setFieldValue("clubId", null);
      formikRef.current.setFieldValue("servicePrice", null);
      formikRef.current.setFieldValue("search", null);
    }
    // setClubId(null);
    setServicePrice(null);
    setSearch(null);
    setData(null);
  };

  const columns = [
    { title: "Club", type: "text", isVisible: true, key: "clubName" },
    { title: "Phone", type: "text", isVisible: true, key: "phone" },
    { title: "Service Type", type: "text", isVisible: true, key: "configType" },
    {
      title: "Notifications",
      type: "number",
      isVisible: true,
      key: "TotalNotifications",
      showTotal: true,
    },
    {
      title: "Amount",
      type: "number",
      isVisible: true,
      key: "TotalAmount",
      showTotal: true,
    },
  ];

  const getClubAccount = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetClubsDDL"
      );
      const data = [
        {
          id: null,
          name: "No Club",
        },
        ...response.data,
      ];
      setAccountList(data);
    });
  };

  const calculatedResponse = async () => {
    setData((prev) => {
      if (!Array.isArray(prev?.data)) {
        toast.error(`First To Fetch Data`);
        return prev;
      }

      return {
        ...prev,
        data: prev.data.map((row) => ({
          ...row,
          TotalAmount: (row.TotalNotifications || 0) * (servicePrice || 0),
        })),
      };
    });
  };

  const getData = async () => {
    setData(null);
    setServicePrice(null);
    const values = formikRef.current.values;
    if (sentAt && tillDate && sentAt > tillDate) {
      Common.showToast("End Time must be greater", "Error", "Info");
      return;
    }

    const params = new URLSearchParams();

    if (values.sentAt) params.append("sentAt", values.sentAt);

    if (values.tillDate) params.append("tillDate", values.tillDate);

    if (formikRef.current?.values.clubId?.length > 0) {
      const ids = formikRef.current.values.clubId.map((x) => x.value);
      params.append("clubId", ids.join(","));
    }
    if (values.search) params.append("search", values.search);

    if (formikRef.current?.values.clubConfigLogType?.length > 0) {
      const ids = formikRef.current.values.clubConfigLogType.map(
        (x) => x.value
      );
      params.append("clubConfigLogType", ids.join(","));
    }

    if (values.grouped) params.append("grouped", values.grouped);

    console.log("Params", params.toString());

    const response = await Common.ApiService.getInstance().request(
      `GetClubNotificationLogs?${params.toString()}`
    );
    console.log(params.toString());

    if (response?.data && response.data.length > 0) {
      const processedData = response.data.map((row) => ({
        ...row,
        // TotalAmount: (row.TotalNotifications || 0) * (servicePrice || 0),
        clubName: row.clubName ?? "-",
        configType: Common.Utility.getKeyByValue(
          ClubConfigLogTypeEnum,
          row.configType
        ),
      }));
      let obj = {
        ...response,
        // data: response.data,
        data: processedData,
      };
      setData(obj);
    }
  };

  return (
    <div className="space-y-6 min-h-screen bg-gray-50 p-4">
      {/* Header Section */}
      <div className="bg-gradient-to-r from-[#0C1B3A] to-[#2E55B9] rounded-xl shadow-2xl overflow-hidden">
        <div className="p-6 text-white">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-white/20 rounded-lg">
                <svg
                  className="w-8 h-8"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </div>
              <div>
                <h1 className="text-3xl font-bold">Notification Logs</h1>
                <p className="text-blue-100 mt-1">
                  Track and analyze club notification activities
                </p>
              </div>
            </div>
            <div className="text-right">
              <div className="text-2xl font-bold">
                {data?.data?.length || 0}
              </div>
              <div className="text-sm text-blue-100">Total Records</div>
            </div>
          </div>
        </div>
      </div>

      <Formik
        initialValues={formInitialValue}
        validationSchema={formValidations}
        innerRef={formikRef}
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={onSubmitData}
      >
        {(formikProps) => {
          formikRef.current = formikProps;
          return (
            <>
              {/* Filters Section */}
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl font-bold text-[#0C1B3A] flex items-center gap-2">
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M3 3a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Filter Options
                  </h2>
                  <div className="flex gap-3">
                    <Button
                      onClick={getData}
                      className="bg-[#0C1B3A] hover:bg-[#2E55B9] text-white px-6 py-2 rounded-lg font-semibold transition-colors flex items-center gap-2"
                    >
                      <svg
                        className="w-4 h-4"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Fetch Data
                    </Button>
                    <Button
                      onClick={resetFilters}
                      className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded-lg font-semibold transition-colors flex items-center gap-2"
                    >
                      <svg
                        className="w-4 h-4"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 01-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Reset Filters
                    </Button>
                  </div>
                </div>

                {/* Filter Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                  {/* Date Range */}
                  <div className="space-y-4">
                    <h3 className="font-semibold text-[#0C1B3A] text-lg border-l-4 border-[#2E55B9] pl-3">
                      Date Range
                    </h3>
                    <div className="space-y-4">
                      <FormikInput
                        formikProps={formikProps}
                        label={"From Date"}
                        value={formikProps.values.sentAt}
                        onChange={(e) => {
                          const selectedstartDate = e;
                          if (tillDate && selectedstartDate > tillDate) {
                            Common.showToast(
                              "Start Time must be lesser than End Time",
                              "Error",
                              "info"
                            );
                            setSentAt(null);
                            formikProps.setFieldValue("sentAt", null);
                          } else {
                            setSentAt(selectedstartDate);
                            formikProps.setFieldValue(
                              "sentAt",
                              selectedstartDate
                            );
                          }
                        }}
                        type={"date"}
                        name={"sentAt"}
                        className="w-full"
                      />

                      <FormikInput
                        formikProps={formikProps}
                        label={"Till Date"}
                        value={formikProps.values.tillDate}
                        onChange={(e) => {
                          const selectedEndDate = e;
                          if (selectedEndDate < sentAt) {
                            Common.showToast(
                              "End Time must be greater",
                              "Error",
                              "info"
                            );
                            setTillDate("");
                            formikProps.setFieldValue("tillDate", null);
                          } else {
                            setTillDate(selectedEndDate);
                            formikProps.setFieldValue(
                              "tillDate",
                              selectedEndDate
                            );
                          }
                        }}
                        type={"date"}
                        name={"tillDate"}
                        className="w-full"
                      />
                    </div>
                  </div>

                  {/* Club & Service Filters */}
                  <div className="space-y-4">
                    <h3 className="font-semibold text-[#0C1B3A] text-lg border-l-4 border-[#2E55B9] pl-3">
                      Club & Service
                    </h3>
                    <div className="space-y-4">
                      <FormikMultiSelect
                        formikProps={formikProps}
                        animatedComponents={animatedComponents}
                        label="Service Type"
                        name={"clubConfigLogType"}
                        data={[
                          ...Object.entries(ClubConfigLogTypeEnum).map(
                            ([key, value]) => ({
                              label: key.replace(/_/g, " "),
                              value: value,
                            })
                          ),
                        ]}
                        value={formikProps.values.clubConfigLogType}
                        onChange={(val) =>
                          formikProps.setFieldValue("clubConfigLogType", val)
                        }
                        className="w-full"
                      />

                      <FormikMultiSelect
                        formikProps={formikProps}
                        animatedComponents={animatedComponents}
                        label={"Club"}
                        name={"clubId"}
                        data={accountList.map((item) => ({
                          label: item.name,
                          value: item.id,
                        }))}
                        value={formikProps.values.clubId}
                        onChange={(val) =>
                          formikProps.setFieldValue("clubId", val)
                        }
                        className="w-full"
                      />
                    </div>
                  </div>

                  {/* Search & Options */}
                  <div className="space-y-4">
                    <h3 className="font-semibold text-[#0C1B3A] text-lg border-l-4 border-[#2E55B9] pl-3">
                      Search & Options
                    </h3>
                    <div className="space-y-4">
                      <FormikInput
                        formikProps={formikProps}
                        name={"search"}
                        value={formikProps.values.search ?? ""}
                        onChange={(val) => {
                          setSearch(val);
                          formikProps.setFieldValue("search", val);
                        }}
                        label="Search"
                        placeholder="Search by phone number"
                        className="w-full"
                      />

                      <FormikSwitch
                        formikProps={formikProps}
                        value={formikProps.values.grouped}
                        onChange={(val) =>
                          formikProps.setFieldValue("grouped", val)
                        }
                        label="Group By Record"
                        name={"grouped"}
                        // className="w-full"
                      />
                    </div>
                  </div>

                  {/* Pricing */}
                  <div className="space-y-4">
                    <h3 className="font-semibold text-[#0C1B3A] text-lg border-l-4 border-[#2E55B9] pl-3">
                      Pricing
                    </h3>
                    <div className="space-y-4">
                      <FormikInput
                        formikProps={formikProps}
                        type="number"
                        name={"servicePrice"}
                        value={formikProps.values.servicePrice ?? ""}
                        onChange={(val) => {
                          const parsed = val === "" ? null : Number(val);
                          setServicePrice(parsed);
                          formikProps.setFieldValue("servicePrice", parsed);
                        }}
                        label="Per Message Charges"
                        placeholder="Enter charge amount"
                        className="w-full"
                      />

                      <Button
                        onClick={calculatedResponse}
                        className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2"
                      >
                        <svg
                          className="w-4 h-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                            clipRule="evenodd"
                          />
                        </svg>
                        Calculate Amount
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Data Table */}
              {data?.data && (
                <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                  <div className="bg-gradient-to-r from-[#0C1B3A] to-[#2E55B9] px-6 py-4">
                    <h3 className="text-xl font-bold text-white flex items-center gap-2">
                      <svg
                        className="w-6 h-6"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Notification Logs
                      <span className="bg-white/20 px-3 py-1 rounded-full text-sm">
                        {data.data.length} records
                      </span>
                    </h3>
                  </div>
                  <div className="p-0">
                    <AdvanceTable
                      title={""}
                      columns={columns.filter((item) => item.isVisible)}
                      data={data}
                      getData={getData}
                    />
                  </div>
                </div>
              )}

              {/* No Data State */}
              {!data?.data && (
                <div className="bg-white rounded-xl shadow-lg p-12 text-center">
                  <div className="text-gray-400 mb-4">
                    <svg
                      className="w-20 h-20 mx-auto"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-600 mb-2">
                    No Data Available
                  </h3>
                  <p className="text-gray-500 mb-6">
                    Apply filters and click "Fetch Data" to view notification
                    logs
                  </p>
                  <Button
                    onClick={getData}
                    className="bg-[#0C1B3A] hover:bg-[#2E55B9] text-white px-6 py-2 rounded-lg font-semibold transition-colors"
                  >
                    Fetch Data
                  </Button>
                </div>
              )}
            </>
          );
        }}
      </Formik>
    </div>
  );
};

export default Logs;
